<template>
    <div class="ma-0 pa-0">
        <!-- Online First articles model Current issue -->
        <router-link v-if="currentTabComponent== 'AppOnLineArticle'" :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'home'}}">
            <v-btn large class="mr-3 mr-lg-5 body-1 blue darken-4 nottransform">
                <span class="  white--text" >Online First articles</span>
                <span class=" ml-2 caretdown"></span>
            </v-btn>
        </router-link>
        <router-link v-else :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'online'}}">
            <v-btn small :tile="!textBtn" :text="textBtn"  :outlined="getOutlined(width)"  class="mr-3 mr-lg-5 body-2 blue--text text--darken-4 nottransform">
                <span class=" dropdown-toggle ">Online First articles</span>
            </v-btn>
        </router-link>
         <br v-if="width < 500"/>
        <!-- Current issue -->
        <router-link v-if="currentTabComponent== 'AppCurrentIssue'" :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'home'}}">
            <v-btn large class="mr-3 mr-lg-5 body-1 blue darken-4 nottransform">
                <span class="  white--text" >Current issue</span>
                <span class=" ml-2 caretdown"></span>
            </v-btn>
        </router-link>
        <router-link v-else :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'current'}}">
            <v-btn small :tile="!textBtn" :text="textBtn"  :outlined="getOutlined(width)"  class="mr-3 mr-lg-5 body-2 blue--text text--darken-4 nottransform">
                <span class=" dropdown-toggle ">Current issue</span>
            </v-btn>
        </router-link>
         <br v-if="width < 500"/>
        <!-- All issues -->
        <router-link v-if="currentTabComponent== 'AppAllIssue'" :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'home'}}">
            <v-btn large class="mr-3 mr-lg-5 body-1 blue darken-4 nottransform">
                <span class="  white--text" >All issues</span>
                <span class=" ml-2 caretdown"></span>
            </v-btn>
        </router-link>
        <router-link v-else :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'all'}}">
            <v-btn small :tile="!textBtn" :text="textBtn"  :outlined="getOutlined(width)" class="mr-3 mr-lg-5 body-2 blue--text text--darken-4 nottransform">
                <span class=" dropdown-toggle ">All issues</span>
            </v-btn>
        </router-link>
    </div>
</template>
<script>

import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
    props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data(){
        return{
            textBtn:false,
            number_to_bo_journal : {
                1 : "am.journal.bo",
                2 : "cmj.journal.bo",
                3 : "mb.journal.bo",
            }
        }
    },
    computed:{
        ...mapGetters('library',{
            currentTabComponent:'currentTabComponent',
            bismenudown:'bismenudown',
        }),
         ...mapGetters('header',{
            width:'width',
        }),
    },
    methods:{
         ...mapActions('header',{
            set_width:'set_width',
        }),
        onResize(e) {
            const { scrollWidth, scrollHeight } = e;
            this.set_width(scrollWidth);
        },
        getOutlined(w){
            if(w>500){
                this.textBtn=false;
                return true;
            }
            else{
                this.textBtn=true;
                return false;
            }
        },
        getJournalRouteName() {
            if (this.bo) {
                let journal_name = this.number_to_bo_journal[parseInt(this.$route.params.journal_id)];
                if (journal_name) {
                    return journal_name;
                } else {
                    log.error("Could not translate number " + parseInt(this.$route.params.journal_id) + " into journal name");
                    // this will wrongly move the user to the non-bo page
                    return 'journal'; 
                }
            } else {
                return 'journal';
            }
        },
    },
}
</script>
<style scoped>
.btnblue {
     background-color:rgb(37,38,151);
}
.caretdown {
    border-bottom: 10px solid #FFFFFF;
    border-left: 6px solid rgba(0, 0, 0, 0);
    border-right: 6px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    height: 0;
    vertical-align: top;
    width: 0;
}
.nottransform{
    text-transform: none !important;
}
</style>
